// extracted by mini-css-extract-plugin
export default {"divSetores":"SelectSetor_divSetores__OARFm"};